/**
  * @class meleActorCameraGrid
  * @description
  *
  * # Purpose
  * Implements `<mele-actor-cameragrid>` custom web element for showing grid for camera calibration
  */

import meleActor from 'meleActor'
const Algo = require('../../msys/msysAV/src_em/algo.js')
const Draw = require('../../msys/msysAV/src_em/draw.js')

const PROPERTIES = _.extend({}, {
  height: {
    description: 'camera height',
    type: 'number',
  },
  yaw: {
    description: 'camera yaw',
    type: 'number',
    default: 20,
  },
  pitch: {
    description: 'camera pitch',
    type: 'number',
    default: 0,
  },
  roll: {
    description: 'camera roll',
    type: 'number',
    default: 0,
  },
  laterals: {
    description: 'list of lateral distances to draw in meters',
    type: 'array',
    items: { type: 'number' },
    default: [-1, -2, -3, -4, -5, -6],
  },
  longitudals: {
    description: 'list of lateral distances to draw in meters',
    type: 'array',
    items: { type: 'number' },
    default: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  },
}, meleActor._properties)

export default class meleActorCameraGrid extends meleActor {
  init() {
    this.canvas = this.appendChildren({ tag: 'canvas' })
    super.init()
  } // init

  message({ action, params }) {
    if(action==='mmH264Meta' && params.channel===parseInt(this.parentElement.ch)) {
      this.updateCanvas(params)
    }
  } // message

  updateCanvas(params) {
    const { camera, h_pixels, v_pixels } = params
    const { laterals, longitudals, height, yaw: camera_yaw, pitch: camera_pitch, roll: camera_roll } = this
    const rig = Algo.rig({ ...params, camera_height: height, camera_yaw, camera_pitch, camera_roll })
    if(!rig) return
    const { camera_height, project } = rig

    this.canvas.width = h_pixels
    this.canvas.height = v_pixels
    const ctx = this.canvas.getContext('2d')

    const cx = Math.floor(h_pixels/2)
    const cy = Math.floor(v_pixels/2)
    Draw.drawLine(ctx, cx, 0, cx, v_pixels, 'hsla(0, 100%, 50%, 0.80)', 1)
    Draw.drawLine(ctx, 0, cy, h_pixels, cy, 'hsla(0, 100%, 50%, 0.80)', 1)

    for(const LAT of laterals) {
      const LON1 = 1
      const LON2 = 1000000
      const HEIGHT = -camera_height
      const p1 = project([LON1, LAT, HEIGHT], true)
      const p2 = project([LON2, LAT, HEIGHT], true)
      Draw.drawLine(ctx, ...p1, ...p2, 'hsla(51,100%,50%,0.8)', 2)
    }
    for(const LON of longitudals) {
      const LAT1 = laterals[0]
      const LAT2 = laterals[laterals.length-1]
      const HEIGHT = -camera_height
      const p1 = project([LON, LAT1, HEIGHT], true)
      const p2 = project([LON, LAT2, HEIGHT], true)
      const color = LON % 5 === 0 ? 'hsla(96, 100.00%, 50.00%, 0.80)' : 'hsla(51,100%,50%,0.8)'
      Draw.drawLine(ctx, ...p1, ...p2, color, 2)
    }

    Draw.drawText(ctx, 0, 0, `Camera: ${camera}`, 'white', 'left', 'top', 20)
  } // updateCanvas
} // class meleActorCameraGrid

meleActorCameraGrid._properties = PROPERTIES
meleActorCameraGrid.observedAttributes = _.keys(PROPERTIES)
window.customElements.define('mele-actor-cameragrid', meleActorCameraGrid)
